import type { TimeZoneLabelEnum } from '@pm/graphql';
import { Text } from '@pm/ui';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type AppointmentTimeZoneProps = {
  date: Date;
  label?: TimeZoneLabelEnum;
  size?: ComponentProps<typeof Text>['size'];
};

export const AppointmentTimeZone = ({
  date,
  label,
  size = 'label',
}: AppointmentTimeZoneProps) => {
  const { t } = useTranslation('appointments', {
    keyPrefix: 'Appointment.Summary',
  });

  const timeZone = label
    ? t('AppointmentTimeZoneName', { timeZone: t(`TimeZoneLabels.${label}`) })
    : t('AppointmentTimeZone', { date });

  return (
    <div className="flex space-x-s items-center">
      <Text
        size={size}
        color="contentSubdued"
        as="time"
        role="time"
        dateTime={date.toDateString()}
        title={timeZone}
      >
        {timeZone}
      </Text>
    </div>
  );
};
